const modalPhotoEditorUserMyAccount = {
  title: 'Editar Mi Foto'
};

export default modalPhotoEditorUserMyAccount;
